import React, { FunctionComponent } from 'react'
import { T } from '@transifex/react'
import { ERRORS, PERMISSIONS } from '../../../../constants'
import { useAppSelector } from '../../../../state/hooks'
import { selectLineItemQuantityInputError } from '../../../../state/slices/uiStateSlice'
import { isUnfulfilledLineItem } from '../../../../functions/sale'
import { LineItem } from '../../../../models/line-item'
import { useUserManager } from '../../../../ng-compat/hooks'
import { InputErrorMessage } from './InputErrorMessage'

interface Props {
  lineItem: LineItem
}

export const NoReturnPermissionError: FunctionComponent<Props> = ({
  lineItem,
}) => {
  const lineItemQuantityError = useAppSelector(
    selectLineItemQuantityInputError(lineItem.localId)
  )
  const userManager = useUserManager()

  const isUnfulfilled = isUnfulfilledLineItem(lineItem)
  const isInvalidMinQuantity =
    !lineItem.confirmed && lineItemQuantityError === ERRORS.INVALID_MIN
  const hasReturnPermission = userManager.hasPermission(PERMISSIONS.SALE_RETURN)

  return (
    <>
      {!isUnfulfilled && isInvalidMinQuantity && !hasReturnPermission ? (
        <div data-cy="no-permission-return" className="wr-media--center">
          <InputErrorMessage
            showIcon={true}
            errorElement={
              <T
                _str="You don’t have permission to process a return"
                _context="Error message shown when current user does not have permission to make a return"
              />
            }
          />
        </div>
      ) : null}
    </>
  )
}
